module.exports = __webpack_public_path__ + "static/img/guangzhou.77cef01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/guangzhou.png
// module id = 5H0R
// module chunks = 1